import { render, staticRenderFns } from "./dicText.vue?vue&type=template&id=8afb994c&"
import script from "./dicText.vue?vue&type=script&lang=ts&"
export * from "./dicText.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports